import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgHt = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    id="flag-icons-ht"
    viewBox="0 0 640 480"
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill="#d21034" d="M0 0h640v480H0z" />
    <path fill="#00209f" d="M0 0h640v240H0z" />
    <g fill="#f1b517" stroke="#000" strokeWidth={0.2}>
      <path fill="#fff" stroke="none" d="M244.3 179.7h151.4v120.5H244.3z" />
      <path
        fill="#016a16"
        stroke="#016a16"
        strokeWidth={0.3}
        d="m350.5 266.8-31 1-30.7.3s-15.8 5.8-22.3 7.1-5.6 3.4-10.5 4.6c-4 .9-4.5 1.1-6.8 1.3-1.5 0-3.2 1.2-5 2.4v16.7h151.5v-15.9q-2.4-1.3-4.8-2c-2.2-.8-3.7-1.6-7.7-2.5-5-1.1-4.2-3.3-10.6-4.6-6.5-1.3-22.1-8.4-22.1-8.4z"
      />
      <g transform="translate(-80)scale(1.6)">
        <g id="ht-a">
          <path d="M244.5 143.5h1.4l2.6 10.7-.6 3.4z" />
          <path fill="#fff" d="m243 136.3 1 8.3h1l-2-8.2z" />
          <path d="m245.7 154.6-4.3-11.5 1.6-.1 5 14z" />
          <path fill="#fff" d="m239.4 136.5 1.8 8h1.4z" />
          <path d="m241.9 150.6-2.5-5.5 1-.2 4.7 9z" />
          <path fill="#fff" d="m236 138.8 2.9 7.6h1.4l-4.2-7.6z" />
          <path
            fill="#0a328c"
            d="m242.3 151.4-11.5-12.5c-3.6 2.8-2.9 8-2.9 8l13 10.2z"
          />
          <path
            fill="#d20014"
            d="m248.9 158.2-8.5-8.6c-3.6.2-.8 5.5-.6 6.2l9 7.7z"
          />
          <path d="M248.1 156.8 230.6 138l-.7.5 18.6 20.6zm-18.5-20-.4-.5v-.9l-3.6-2.3 1.6 3.7 1.3.2.3.4z" />
          <path d="M227.7 138.1a8 8 0 0 1 2.7-2.2l1 1.5-2.2 1.8-1.5-1z" />
          <path
            fill="#0a328c"
            stroke="#0a328c"
            d="m225.8 141.3.6 1c.4-.1 4-3.5 4-3.5h2.7l.7-.9c-2-2-3.7.3-3.7.3z"
          />
          <path
            fill="#d20014"
            stroke="#d20014"
            d="M228 143c0-1 1.8-3.2 2-3.3 1.3.4 2.5 1.2 3.9-1.8-1.2 1.4-3.5 0-3.5 0l-1 .8v.4l-3 2.8z"
          />
          <path
            fill="#0a328c"
            d="m237.3 154.7-14.4-11.4c-2.5 2.5-.4 10.2-.4 10.2l14 7.6.7-6.4z"
          />
          <path
            fill="#d20014"
            d="m249.2 164-11.9-9.6c-4 .6-.8 6.5-.6 7.2l12.5 6.8z"
          />
          <path d="m248.7 162-25.6-19.2-.5.6 26.8 21zm-26.8-20.2-.4-.4-.2-.8-4-1.7 2.3 3.3h1.3l.4.4z" />
          <path d="M220.3 143.4a8 8 0 0 1 2.3-2.6l1.2 1.3-1.8 2.1z" />
          <path
            fill="#0a328c"
            stroke="#0a328c"
            d="M219 146.6v1.1c.4-.2 3.7-3.7 3.7-3.7l2.5-.5.6-.8c-1.8-2.1-3.7.7-3.7.7z"
          />
          <path
            fill="#d20014"
            stroke="#d20014"
            d="M221 148.5c-.2-1 1.2-3.8 1.4-4 1.6.5 3 1.2 3.5-2-1 1.6-3.5.4-3.5.4l-.8 1v.5l-2.5 3.3z"
          />
          <path
            fill="#0a328c"
            d="m236.2 161.7-18.5-10.5c-1.3 2.3-.1 5.5.5 6 0 1.5-.6 2.3.7 5.5q.6 3.2 2.7 5c1.6 6.4 8.2 6.9 10.7 1.6z"
          />
          <path
            fill="#d20014"
            d="m248.3 168.5-12.5-7.3c-4 .5 0 8 .3 8.7l12.2 4.3z"
          />
          <path d="m246.2 165.8-28.3-15-.5.6 30 16.7zM216.5 150l-.5-.3-.3-.8-4.1-1 2.7 2.9 1.2-.2.6.3z" />
          <path d="M215.2 151.8q.4-1.4 1.8-3l1.4 1.1-1.4 2.4z" />
          <path
            fill="#0a328c"
            stroke="#0a328c"
            d="m214.1 155.2.6 1.2 3-4.6 2.5-.9.5-1c-2-1.8-3.5 1.4-3.5 1.4z"
          />
          <path
            fill="#d20014"
            stroke="#d20014"
            d="M216.8 156.8c-.2-1 .5-4.2.7-4.3 1.5.5 2.8.6 3.2-2.6-1 1.5-3.3 1-3.3 1l-.7 1 .1.4-2 4z"
          />
        </g>
        <use
          xlinkHref="#ht-a"
          width="100%"
          height="100%"
          transform="matrix(-1 0 0 1 499.9 0)"
        />
      </g>
      <g transform="translate(-80)scale(1.6)">
        <path
          fill="#016a16"
          stroke="#016a16"
          d="m248.8 125.6-.5 9h2.9l-.4-9 3-.3-.3-3.6-7.5.3v3.2z"
        />
        <g id="ht-b" fill="#016a16">
          <path d="M249.8 121.9c-7.8-7.8-13.9-4-15.3-2.9 1 .2 1.8-.4 2.3-.5l-1 1.2s2.5-1 2.8-1c-.4.3-.8 1-.8 1 .2 0 1.6-1.1 1.8-1.1-.4.4-.5 1.5-.5 1.5l1.2-.5c.3.2-.1.6.1.6 2-.2 4.7 1.7 5 2.3" />
          <path d="M247.9 123.3c-.8-1.8-15.6-5-18.6.3 1.2.3 2.3-1 2.3-1v1.2l1.9-1.6-.7 1.6 1.5-1.3v1.3l2-2-.3 1.1 1.7-.7-.2 1" />
          <path d="M247.2 123.6c-3.8-2.5-9.6-.8-9.6-.8-3.8 2-5.8 1.7-6.2 5.6.3-.1 1.3-1.4 1.3-1.4l.8 1.5.2-2.1.6 1.7 1-2.8.2 1.9 1.4-1.9.6.6.6-1.5.6 1s1-.6 1.5-.3l1-1.2.3.9 1-1 .3.7.9-.8v.6h3" />
          <path d="M246.4 124c-2.7 0-10.3 2.9-12.2 5.8l1.3-.6.3 1.2.5-1.2.1 1q.4-1.2 1.2-.1l.2-1.1.3 1 .5-1.1s.3 1.2.5 1.2c0 0 .8-2.2 1.2-2.3l.1 1.4.5-1.4.5 1v-1.4l.6 1s.2-1 .6-1.2l.8.7 3.4-2.5" />
          <path d="M246.9 124.7c-3.5 1.3-6.7 6.2-6.4 8.2 1.5-2 1.2-1.7 1.9.6 0 0 .2-2 .5-2.2l.5 1.4.1-1.9h.5l-.1-1.1.7.5c-.2-.7-.3-.9.4-1.5 0 0-1 .1-.2-1.5l.7.6s-.2-.7 0-1l2.6-.8" />
          <path d="m247.2 125-1.3 2.6.7.2-1.6 1.1 1.3-.1s-2 .7-2.2 2.7l2-1s-1.7 1.8-2 2.9l1.3-1s-1.2 1.2-1 3l.9-1c-.2 2.3-.2 2.5.8 4.2 0 0-.2-2.6 0-3l2.3 2.4-1.2-3.3s1.4 2 2.2 1.9l-1.8-2.7 1.8 1.4-2-3 1.8.6s-1.3-1.7-1.2-2.8l1.3 1.4s-.5-1.5-.4-2l.7.1-1.3-1.4.9-.2-.1-1 .6-.1v-1.1m-1.1 0c-2.2 3-1.1 7.5-2.4 9.9" />
        </g>
        <use
          xlinkHref="#ht-b"
          width="100%"
          height="100%"
          transform="matrix(-1 0 0 1 499.9 0)"
        />
        <path d="M251 166.5s1.1-10 1.1-14.2c0-3.4-.8-10.8-.8-10.8H248s-.5 7.4-.4 10.8c0 4.2 1.1 14.2 1.1 14.2z" />
        <path d="M247.7 142h4l-.5-2.7h-2.9z" />
        <path d="M248 139.8h3.5l-.7-2.7h-2.2z" />
        <path d="M248.2 137.7h3l-.6-2.7h-1.9z" />
        <path d="M250.7 134.7h-2l-.3 1h2.5zm.4 29.7h-2.6m2.8-2h-3m3.4-2h-3.8m4-2.1h-4m4-2.2h-4.1m4.2-2h-4.4m4.4-1.7h-4.6m4.6-2.2h-4.6m4.5-2.1h-4.5m4.3-2.2h-4.1m3.9-2h-3.7" />
        <path
          fill="#0a328c"
          stroke="#0a328c"
          d="M250 119c-.8-.3-2.3-1.3-1.9-1.9l.7-1.2c1-2.2 0-1.4 0-2-.2-.8 3.8-.2 3.8 1.3 0 .5-.3.2-.2 2.6l-.8 1.5z"
        />
        <path d="m250.4 125-1-.9.3-7.1 1 .3-.3 7.6z" />
        <path
          fill="#d20014"
          stroke="#d20014"
          d="M251.7 119.3c.6-.4 1-1.5.6-2.1-1-1.3-1.7-.8-3.4-1.4-.3.4-1 1-.9 1.6 2.3 1 1.4.2 2.2.3.4 0 .6.5 1.5 1.5z"
        />
      </g>
      <g transform="translate(-80)scale(1.6)">
        <use
          xlinkHref="#ht-c"
          width="100%"
          height="100%"
          transform="matrix(1 0 0 -1 0 320.4)"
        />
        <path
          fill="#016a16"
          stroke="#fff"
          strokeLinecap="round"
          d="M238.4 161.8c0 1.2-.9 2.3-1.9 2.3s-1.8-1-1.8-2.4v-1.2h3.7z"
        />
        <ellipse
          cx={236.5}
          cy={160.1}
          fill="#fff"
          stroke="none"
          rx={1.8}
          ry={0.9}
        />
        <path
          fill="#016a16"
          stroke="#f1b517"
          d="m236.1 161-.3-3.2h1.4l-.2 3.3h-.9z"
        />
        <path
          id="ht-c"
          fill="#016a16"
          stroke="#fff"
          strokeLinecap="round"
          d="M238.5 160.1q-.4.8-2 .9c-1.6.1-1.7-.4-2-.9v.4q.2 1.1 2 1.2 2 0 2.1-1.2z"
        />
        <g id="ht-d">
          <path d="m246 172.8-7-2.2-3.1-5.3-10.9-.5.4 4 9.3 1.7.8 1.6 10.7 3z" />
          <path fill="#503200" d="m238.7 174.3-11.2-16.5-.5.5 11 16.4z" />
          <path
            fill="#fff"
            d="m228.6 158.5-1.2-2q-.4-.6-1.1-.2-.6.4-.2 1.1l1 1.9z"
          />
          <path d="m240 164.1-22.5-2.3-.6 3.3 22.4 2.3z" />
          <path d="m217 161-.5 4.5h1l.6-4.1zm3.8.7-.2 4.1h.6l.5-3.5zm15.3 1.8-.6 3.8h1.1l.5-3.8zm3.3.1-.7 4.4 1.2.2.4-2.3q.1.8 1 .8 1-.1 1-1t-1-1a1 1 0 0 0-1 .6l.3-1.6zm-8 .7-3.2 3.5.4.4 4-2.7zM224 173l3.1-3.5-.3-.4-4 2.7zm8.1-.9-3.7-2.9-.4.3 3 3.8zm-9.3-6.7 3.9 2.8.4-.3-3-3.8zm4.2-2.3.4 4.6h.5l1.2-4.5zm1.2 11-.3-4.5h-.6l-.7 4.6zm5.1-6-4.8.4v.5l4.8.6zm-11.4 1.5 4.7-.7v-.4l-4.8-.5v1.6z" />
          <ellipse cx={227.7} cy={168.6} rx={1.3} ry={1.2} />
          <path
            fillRule="evenodd"
            strokeLinecap="round"
            d="M234.4 168.6c0 3.5-3 6.5-6.7 6.5a6.6 6.6 0 0 1-6.7-6.5c0-3.6 3-6.5 6.7-6.5a6.6 6.6 0 0 1 6.7 6.5zm-1.3 0a5.3 5.3 0 0 1-5.4 5.2 5.3 5.3 0 0 1-5.4-5.3 5.3 5.3 0 0 1 5.4-5.1 5.3 5.3 0 0 1 5.4 5.2z"
          />
          <path d="m223.5 165.3-1-.8m8.5 0 1-1m1 9.2-1.1-.9m-8.4 1.9 1-1m21.7-10.6 1.1 6-.9.4-1-6.3z" />
          <path
            fill="#fff"
            d="M245.6 161.4c-.5-.3-1.2.1-2.4-1.3-1.9 1.7 0 2 .2 3.7.5.2.9-1.4 2.3-1.5l2.3-.2-.5-.7z"
          />
          <path fill="#fff" d="m246.4 162.5-.2-1.7c-.3-.7-1-.1-1 .2l.2 1.7z" />
          <path
            fillRule="evenodd"
            d="M240.8 167.4v1.6c-.6.2-.5.6-.5 1.2v4.7q-.3.5-1 .6-.6.6 1 1l1 .1q2.2-.6 1-1-.7-.3-1-.6v-1.2h1c.2 0 .7-.6.7-1.1v-2.5c0-1.4-1-1.6-1.4-1.5v-1.3zm1.6 2.7c0-.4-.6-.8-.8-.8q-.5.2-.7.9v1c0 .4.3 1.6.9 1.7q.4-.1.6-.8z"
          />
          <path
            fill="#fff"
            d="M234.3 172.3c-.7-.2-.7 1.2-.7 1.2h1q.8.4.6 1.2c-.3.2-2.2-.5-2.3 0 .3 1.9 2.9 2.6 3.8 1.8s1.1-3-1.8-3.7zm.6.6-.3.6"
          />
          <path d="m215 173-1-4m2.1 3.8-1.5-3.1m4 2.3-3.3-1.8m4.8 1.4-6.2-2.7" />
          <path
            fill="#d20014"
            stroke="#d20014"
            d="m210.2 166-2.6.1c-.2.1.5.9.4 1.1-.6 1.1-4.4 1-4.7.8-.5-.5 3.5-.8 3.6-1 0-.4-.6-1.2-.5-1.7 0-.7 1.7-1 1.7-1z"
          />
          <path
            fill="#503200"
            d="m213.2 168-5-4.2s-.3-.2-.5 0 0 .4 0 .4l5.4 4.4.1-.5z"
          />
          <path d="m218.2 172.2-4.2-3.6-.3-1-.8.6c-.3.2-.6.8-.6.8h1.1l3.6 3.4 1.1-.2z" />
          <circle cx={232.5} cy={177.1} r={0.7} />
          <circle cx={230.6} cy={175.7} r={0.7} />
          <circle cx={228.1} cy={176.6} r={0.7} />
          <circle cx={224.2} cy={177.4} r={0.7} />
          <circle cx={222.5} cy={177.6} r={0.7} />
          <circle cx={220.8} cy={177.6} r={0.7} />
          <circle cx={219.2} cy={177.6} r={0.7} />
          <circle cx={220} cy={176.3} r={0.7} />
          <circle cx={221.6} cy={176.4} r={0.7} />
          <circle cx={223.1} cy={176.2} r={0.7} />
          <circle cx={222.4} cy={175} r={0.7} />
          <circle cx={220.8} cy={174.9} r={0.7} />
          <path
            fillRule="evenodd"
            d="M236.5 178c0-.3-.8-.2-.8-.6s1.2 0 1.3.3c.7-.6 1-.2 1.4 0q1-1.2 2-.2c.4-.4 1.4-.3 1.7.2q1-.8 1.7 0 .3-.5.7 0c.3-.7 1.2-.5 1.6 0 .3-.4.7-.1 1.1.1q.6-.3.8 0c0 .4-.6.3-.6.6s.4 0 .4.4c0 .3-.6.4-.7 0-.3.4-1.1.2-1.2-.2a1 1 0 0 1-1.2 0q-.5.3-.8 0c-.5.5-1.4.4-1.7-.2h-.3a1 1 0 0 1-1.5 0q-1.2.8-1.9 0c-.5.7-1.4.7-1.5 0-.4.3-1.2.4-1.2 0 0-.2.7-.1.7-.4zm1.6.1q0 .3-.4.3t-.4-.3.4-.2zm1.9-.2q0 .3-.6.3t-.5-.3q0-.2.5-.3t.5.3zm3.5.2q0 .3-.5.3t-.4-.3q0-.2.4-.3.6 0 .5.3zm-1.9 0q0 .3-.5.3t-.4-.4.4-.4q.5 0 .5.4zm4 0q0 .2-.3.3-.5 0-.5-.4t.5-.3q.3 0 .4.3zm-1.2 0q0 .3-.2.3t-.3-.3q0-.3.3-.2zm2.4.1q0 .3-.3.4-.2 0-.3-.4t.3-.3q.3 0 .3.3z"
          />
        </g>
        <use
          xlinkHref="#ht-d"
          width="100%"
          height="100%"
          transform="matrix(-1 0 0 1 499.9 0)"
        />
        <path
          fill="#0a328c"
          stroke="#0a328c"
          d="M249.8 165.7c-2.5 0-4.5 1-4.5 2.1l.2.6c.5.6 2.3 1 4.4 1q3.2 0 4.2-.9.3-.3.3-.7c0-1.1-2-2-4.6-2z"
        />
        <path d="M254.4 168v7c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-7c0 .8 2 1.5 4.5 1.5 2.6 0 4.6-.7 4.6-1.5z" />
        <path
          fill="#d20014"
          stroke="#d20014"
          d="M245.3 168v1l2.2 7 1.8-5.4 2 5.5 1.3-5.2 1.8 3.5v-1.9l-1.6-3.4-.6.2-1 3.8-1.5-3.6h-.7l-1.5 3.6-1.6-4.4q-.6-.3-.6-.7z"
        />
        <path
          fill="#0a328c"
          stroke="#0a328c"
          d="M254.4 173.7v1.3c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-1.3c0 .9 2 1.5 4.5 1.5 2.6 0 4.6-.6 4.6-1.5z"
        />
        <path d="m251.7 175-1.1.2v1.3l1.2-.1zm-4.8-.1v1.3l1.1.2v-1.3zm-1.6-1.2v1.3q0 .4.5.7v-1.3q-.5-.3-.5-.7zm9.1.2q-.1.3-.8.7v1.3q.8-.3.8-.9z" />
        <path
          fill="none"
          d="M254.4 168v7c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-7"
        />
        <path
          fill="#fff"
          stroke="#fff"
          d="M253.4 167.5c0 .5-1.6 1-3.5 1-2 0-3.6-.5-3.6-1s1.6-.9 3.5-.9c2 0 3.6.4 3.6 1z"
        />
        <path d="m248.7 168.2.2 1.2h1l.1-1.2zm4.1-.3-1 .2.1 1.2 1-.2zm-5.4-2-.7.3.1 1 .6-.2zm2.4-.3h-.3l.2 1.2h.6l.2-1.2zm2.7.4-.1 1 .7.3v-1zm-6.5 2.8.2-1.3-1-.5v1.5zm8.4-.3v-1.3l-.8.3zm9.3-8.5c.8 0 2 1 2.1 2.5 0 1-1.7 1-1.7 1 0 .5-1 .9-1.8 1s.2-1.5.2-1.5c-.5-1.3.2-2.7.2-2.7z" />
        <path d="M262.5 163h.8s0 .3.2.3.3-.4.3-.4h1.2" />
        <path
          fill="#d20014"
          stroke="#f1b517"
          d="M264.1 160.9c.7-.5.1-1.5-.4-1.5h-1c-.6 0-1.4.6-1.3 1q.1.8.8.6c.2 0 .6-.6.8-.6s1 .6 1.1.5z"
        />
        <path
          fillRule="evenodd"
          d="M214.2 174.8q-.8.3-.5 1.5l-7.4 2.4c-.1-.5 1.2-1.8 1.2-1.8.3.1.6.9.6.9 0-1.6 1.6-2.6 1.6-2.6-1-.2-3.7 1-4 1.4 0 0 1-.2 1.2 0 0 0-2.2 2.3-2.3 3 .4.7 4 1.3 4 1.3 0 .2-1 1-1 1 1.5.2 3.7-.8 4.3-1.4 0 0-1.7-.2-3-1.3 0 0 .2.7 0 1 0 0-2-.6-2.3-1 0 0 5-1.2 7.4-2 .1.5.6 1.3 1.2 1.1q.4-.3 0-1.4l.6.2q.7 0 .7-.7t-.7-.7l-.7.5c-.1-.5-.4-1.4-.8-1.3zm2 1.6q0 .3-.4.3a.3.3 0 0 1-.4-.3q0-.3.4-.4.4 0 .3.4z"
        />
        <path d="M293 177.9c.2-.4 0-2.2 0-2.2-.5 0-1 .7-1 .7.5-1.6-.8-4-.8-4 .9.1 3.9 3 4 3.6 0 0-1.3-.5-1.5-.4.3 1.5 1.3 2.2 1.7 3 0 0-1.7.3-1.6 1.8h-1.1c-.4-.5.1-1.3.1-1.3l-7.7-3.2c-.5-.2-1.6-.8-1.4-1.4.1-.5 2 .3 2.4.5z" />
        <path d="m285.6 176.5 1-1.6c.3-.5-.4-1-.9-.4l-1 1.5c-.4.9.5 1.1 1 .5z" />
      </g>
      <g fill="#fff" strokeWidth={0.3}>
        <path d="m290.2 288.6-.1-3-3.5.3-.2 3.1z" />
        <path d="m264.4 292.7-4.7-2.7c19.4 1.8 23.4-5 28.1-5.3 3-.3 3.3 3.2-2.3 1.5l1.5 3.6s-13.8 7.8-27.4 4.6zm84.8-4.1.1-3 4.3.2.2 3.1z" />
        <path d="m375.9 292 4.5-2.5c-22.4.7-17.3-3.6-28.4-4.8-3-.4-5 3.4 2.2 1.5l-1.4 3.6h3.5c7.6 5 17.8 5.5 24.6 3.9z" />
        <path d="M285.5 286.3v5s12.3 4.6 34.4 4.6c22.2 0 34.4-4.6 34.4-4.6v-5s-9.3 4.3-34.4 4.3-34.4-4.3-34.4-4.3z" />
      </g>
      <path
        fill="#000001"
        stroke="none"
        d="m287.3 291.3 1.1-3.7.5.2-1 3.2 2 .5-.2.5zm3.6-1.6v-.7l.2-.7.6.2-.2.6-.3.7zm5.3-.3.5.2-.4 2.1-.4 1-.5.4h-1l-.9-.4-.4-.6.1-1 .5-2.2.5.1-.5 2.2v.8l.2.4.5.2h1l.4-1zm.6 4 .6-3.7h.6l1.5 3.4.5-3h.5l-.6 3.9-.5-.1-1.6-3.3-.5 3zm4 .7.6-3.8h.5l-.5 3.8h-.5zm1.6-1.7q0-1 .7-1.4a2 2 0 0 1 1.4-.4q.6 0 1 .3l.5.8q.3.5.1 1l-.3 1-.8.7-1 .1-1-.3-.5-.8zm.5 0q0 .8.3 1.2.3.5.9.5t1-.3.5-1v-1l-.5-.5-.7-.3q-.5 0-1 .3-.3.3-.5 1.2zm3.7 2.3.3-3.8h.6l1.8 3.2.2-3h.5l-.3 3.9h-.5l-1.9-3.2-.2 3zm5.6.4.1-3.8 2.7.1v.5l-2.1-.1-.1 1.1 1.9.1v.5l-2-.1v1.8zm3 .1 1.5-3.8h.6l1.5 4h-.6l-.4-1.3h-1.7l-.4 1.2zm1-1.5h1.4l-.4-1-.2-.9-.2.8-.5 1.1zm3.1 1.6v-3.8h.6v3.8zm2.5 0V292h-1.3v-.4h3.1v.4h-1.3v3.4zm4 0-.3-4h.6l.1 3.4h2v.4zm2.6-.2 1.2-4h.6l2 3.7h-.7l-.5-1h-1.7l-.3 1.3zm1-1.7h1.4l-.5-1-.4-.9-.1.8zm4.7 1.2-.4-3.8 2.6-.3.1.5-2.1.2v1.2l2-.2v.5l-1.9.2.2 1.7zm3-2.1a2 2 0 0 1 .2-1.6 2 2 0 0 1 1.3-.7l1 .1q.6.1.8.6l.4 1-.1 1-.6.8-.9.4-1-.1-.8-.6zm.5-.1q0 .6.5 1t1 .3q.7-.1 1-.5t.2-1.2l-.3-.8-.6-.5h-.7q-.6 0-1 .4-.2.4-.1 1.3m4.1 1.3-.6-3.8 1.7-.3h.8q.3 0 .5.2l.3.6q0 .4-.2.7t-.7.5l.3.1.5.5 1 .9h-.7l-.7-.6-.5-.5-.3-.2h-.6l-.6.1.4 1.7zm.2-2.2 1-.2.6-.2.3-.6-.2-.4h-.7l-1.3.1zm6.3-.4h.5q0 .6-.3 1l-1 .6h-1l-.8-.6-.5-1v-1q.1-.6.5-.9l.9-.4h1q.6.3.8.8l-.5.2-.5-.5h-.7l-.7.3-.3.7v.7l.4.8q.2.4.6.4h.7l.6-.3q.3-.3.3-.8m1.4 1-1-3.7 2.7-.7.2.4-2.3.6.3 1.1 2.1-.5.2.4-2.2.6.4 1.2 2.4-.6v.4z"
      />
    </g>
  </svg>
);
export default SvgHt;
